export enum MaterialType {
  MarketingMaterial = 1,
  Article = 2,
}
